import {
    DIGITS_PER_DRAW,
    DRAW_INTERVAL_MS,
    HISTORY_SIZE,
    SEED_SALT,
    TOTAL_NUMBERS,
} from '../constants/lottery';
import { createRandom, mixSeed, randomInt } from './rng';

// Draw scheduling and results.
//
// The timeline is a fixed grid of DRAW_INTERVAL_MS slots anchored at epoch,
// so a 30-minute interval lands on :00 and :30 of every hour. The draw for
// slot N happens at the START of slot N — meaning "the latest result" is
// always the one belonging to the current slot, and the countdown runs to
// the start of the next one.
//
// Results are derived from (sessionSeed, slotIndex), never stored. That is
// what lets a first-time visitor see ten plausible past draws instantly.

export function slotIndexAt(timestamp) {
    return Math.floor(timestamp / DRAW_INTERVAL_MS);
}

export function slotStartAt(slotIndex) {
    return slotIndex * DRAW_INTERVAL_MS;
}

export function nextDrawAt(slotIndex) {
    return slotStartAt(slotIndex + 1);
}

export function padNumber(value) {
    return String(value).padStart(DIGITS_PER_DRAW, '0');
}

export function toDigits(paddedNumber) {
    return paddedNumber.split('').map(Number);
}

export function resultForSlot(slotIndex, sessionSeed) {
    const random = createRandom(mixSeed(sessionSeed + slotIndex, SEED_SALT.DRAW));
    // Burn the first value: mulberry32's first output correlates across
    // nearby seeds, which would make consecutive draws share a leading digit.
    random();
    const number = padNumber(randomInt(random, TOTAL_NUMBERS));

    return {
        slotIndex,
        number,
        digits: toDigits(number),
        drawnAt: slotStartAt(slotIndex),
    };
}

// Newest first, current slot included.
export function historyUpTo(slotIndex, sessionSeed, size = HISTORY_SIZE) {
    return Array.from({ length: size }, (_, offset) => resultForSlot(slotIndex - offset, sessionSeed));
}
